import { Button, Box } from '@mui/material';
import {
  setPlayerTeam, addPlayerToTeam, removePlayer, resetAllTeamsStats,
} from 'redux/slices';
import { useSelector, useDispatch } from 'react-redux';
import { computeBalancedTeams } from '../utils/balanceTeams';

export function BalanceTeamsBtn() {
  const players = useSelector((state) => state.players);
  const genderBalanceMode = useSelector((state) => state.game.genderBalanceMode);
  const genderRestrictedMode = useSelector((state) => state.game.genderRestrictedMode);
  const setterRestrictedMode = useSelector((state) => state.game.setterRestrictedMode);
  const dispatch = useDispatch();

  const balanceTeams = () => {
    const { teamA, teamB, waitingPlayers } = computeBalancedTeams({
      players, genderBalanceMode, genderRestrictedMode, setterRestrictedMode,
    });

    teamA.forEach((player) => {
      dispatch(setPlayerTeam({ playerId: player.playerId, teamId: 1 }));
      dispatch(addPlayerToTeam({ playerId: player.playerId, teamId: 1 }));
    });

    teamB.forEach((player) => {
      dispatch(setPlayerTeam({ playerId: player.playerId, teamId: 2 }));
      dispatch(addPlayerToTeam({ playerId: player.playerId, teamId: 2 }));
    });

    // Quem sobra volta para a fila (removePlayer também zera isPlaying; antes ficava "fantasma").
    waitingPlayers.forEach((player) => {
      dispatch(removePlayer(player.playerId));
    });

    dispatch(resetAllTeamsStats());
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100px',
      }}
    >
      <Button variant="contained" color="secondary" onClick={balanceTeams} size="small">Balancear times</Button>
    </Box>
  );
}
